<template>
  <div class="grid-settings">
    <v-card class="elevation-0" tile>
      <v-tabs
        v-model="selectedTab"
        background-color="primary"
        dark height="64"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          Grid Settings
        </v-tab>
        <v-tab>
          Layout Info
        </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item>
        <settings-form @submit="onSubmit"></settings-form>
      </v-tab-item>
      <v-tab-item>
        <layout-info @submit="onChange"></layout-info>
      </v-tab-item>
    </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import SettingsForm from '@/components/SettingsForm.vue';
import LayoutInfo from '@/components/LayoutInfo.vue';

export default {
  name: 'grid-settings',
  components: {
    SettingsForm,
    LayoutInfo,
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  methods: {
    onSubmit(settings) {
      this.$store.commit('updateSettings', settings);
      this.selectedTab = 1;
    },
    onChange() {
      this.selectedTab = 0;
    },
  },
};
</script>
